import { DynamicField } from '@/components/ui'
import type { ConfigField } from '@/modules/projects/stores/caseConfig'

interface CaseDetailFieldsProps {
  fields: ConfigField[]
  values: Record<string, string>
  onChange: (key: string, value: string) => void
  onCommit?: (key: string, value: string) => void
}

export const CaseDetailFields = ({
  fields,
  values,
  onChange,
  onCommit,
}: CaseDetailFieldsProps) => {
  if (fields.length === 0) return null

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {fields.map((field) => (
        <DynamicField
          key={field.key}
          field={field}
          value={values[field.key] ?? ''}
          onChange={(value) => onChange(field.key, value)}
          onCommit={
            onCommit ? (value) => onCommit(field.key, value) : undefined
          }
        />
      ))}
    </div>
  )
}
